import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

const articlesSwipers = document.querySelectorAll(".js-articles-mobile-swiper-init");

if (window.mobileMedia && articlesSwipers) {
    articlesSwipers.forEach((slider) => {
        initIntersectionObserver(slider, articlesSwiperInit);
    });
}

function articlesSwiperInit(slider) {
    const swiperContainer = slider.querySelector(".js-articles-swiper-container");
    const swiperComtrols = slider.querySelector(".js-articles-swiper-controls");
    const swiperPagination = swiperComtrols?.querySelector(".swiper-pagination");

    if (swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 17,
            pagination: {
                el: swiperPagination,
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            observer: true,
            watchOverflow: true,
            breakpoints: {
                567: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            },
        });
    }
}
